// @ts-nocheck

import { request } from '../../context';
import type { ApiOptions } from '../../context';
import type { PostCorporaStaticTotalHotWordsQuery, BaseResponseint } from '../../types';

/**
 * 查询热词数量
 *
 * @export
 * @tags 热词, 语料库
 * @link [POST] /corpora/staticTotalHotWords
 */
export function postCorporaStaticTotalHotWords(
    options: ApiOptions<never, PostCorporaStaticTotalHotWordsQuery> & {
        params: PostCorporaStaticTotalHotWordsQuery;
    }
): Promise<BaseResponseint> {
    return request<never, never, PostCorporaStaticTotalHotWordsQuery>(
        '/corpora/staticTotalHotWords',
        { ...options, method: 'post', __$requestCalleeName: 'postCorporaStaticTotalHotWords' }
    );
}

export const meta = [
    { tags: ['热词', '语料库'], path: '/corpora/staticTotalHotWords', method: 'post' },
];
